import { Box } from 'src/components/Box';
import { useSession } from 'src/contexts/SessionContext';

interface Props {
  height?: number | string;
  width: number | string;
}

export const LogoImage: React.FC<Props> = ({ height, width }) => {
  const { session } = useSession();

  return (
    <Box
      component="div"
      borderRadius={1}
      sx={{
        backgroundColor: 'neutral.50',
        display: 'flex', // Enable flex container
        justifyContent: 'center', // Center horizontally
        alignItems: 'center',
        height: height || 'auto',
        width: width,
        aspectRatio: '6 / 5',
      }}
    >
      <Box
        component="img"
        src={session.logoUrl}
        sx={{
          mx: '10%',
          maxWidth: '60%',
          maxHeight: '50%',
        }}
      />
    </Box>
  );
};
